module.exports = __webpack_public_path__ + "assets/img/317643dd5d4fa57d39fe8df5290b3b22.png";